var map = {
	"./menu.yaml": 506,
	"./site.yaml": 507,
	"./tags.yaml": 508
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 808;


//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*$
// module id = 808
// module chunks = 1474